import React, { ReactElement, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from './bootstrap/OffCanvas';
import Button from './bootstrap/Button';

interface IDropWindowProps {
	setOpen: React.Dispatch<SetStateAction<{ open: boolean; type: string }>>;
	isOpen: { open: boolean; type: string };
	placement: 'start' | 'end';
	name: string;
	children: ReactElement;
}

const DropWindow = (props: IDropWindowProps) => {
	const { t } = useTranslation(['translation', 'menu']);

	return (
		<OffCanvas
			setOpen={props.setOpen}
			isOpen={props.isOpen.open}
			titleId='upcomingEdit'
			isBodyScroll
			placement={props.placement}
			isBackdrop={false}>
			<OffCanvasHeader setOpen={(e: boolean) => props.setOpen({ open: e, type: 'edit' })}>
				<h4 id='upcomingEdit'>{props.name}</h4>
			</OffCanvasHeader>
			<OffCanvasBody>{props.children}</OffCanvasBody>
		</OffCanvas>
	);
};

export default DropWindow;
